const API_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_URL) {
  console.error('REACT_APP_BACKEND_URL environment variable is not configured');
}

export const analyticsAPI = {
  // Get overview KPIs
  getOverview: async () => {
    const response = await fetch(`${API_URL}/api/analytics/overview`);
    if (!response.ok) {
      throw new Error('Failed to fetch overview data');
    }
    return response.json();
  },

  // Get supply vs demand data
  getSupplyDemand: async () => {
    const response = await fetch(`${API_URL}/api/analytics/supply-demand`);
    if (!response.ok) {
      throw new Error('Failed to fetch supply-demand data');
    }
    return response.json();
  },

  // Get NRW trends
  getNRWTrends: async () => {
    const response = await fetch(`${API_URL}/api/analytics/nrw-trends`);
    if (!response.ok) {
      throw new Error('Failed to fetch NRW trends');
    }
    return response.json();
  },

  // Get NRW distribution
  getNRWDistribution: async () => {
    const response = await fetch(`${API_URL}/api/analytics/nrw-distribution`);
    if (!response.ok) {
      throw new Error('Failed to fetch NRW distribution');
    }
    return response.json();
  },

  // Get water quality data
  getWaterQuality: async () => {
    const response = await fetch(`${API_URL}/api/analytics/water-quality`);
    if (!response.ok) {
      throw new Error('Failed to fetch water quality data');
    }
    return response.json();
  },

  // Get system alerts
  getAlerts: async () => {
    const response = await fetch(`${API_URL}/api/analytics/alerts`);
    if (!response.ok) {
      throw new Error('Failed to fetch alerts');
    }
    return response.json();
  },

  // Get flow hierarchy
  getFlowHierarchy: async () => {
    const response = await fetch(`${API_URL}/api/analytics/flow-hierarchy`);
    if (!response.ok) {
      throw new Error('Failed to fetch flow hierarchy');
    }
    return response.json();
  },
};
